<div class="bg-white min-h-screen py-12 px-6 xl:px-[224px]">
    <div class="max-w-[1472px] mx-auto flex flex-col gap-8">
        <h1 class="text-heading text-[32px] leading-[40px] font-semibold">{{ 'home.brands' | translate }}</h1>

        <ng-container *ngIf="brands$ | async as brands; else skeleton">
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                <ng-container *ngFor="let brand of brands">
                    <a *ngIf="brand.link; else noLink"
                       [href]="brand.link"
                       target="_blank"
                       class="flex flex-col items-center justify-center gap-3 bg-surface rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer">
                        <img [src]="brand.asset?.preview"
                             [alt]="brand.name || 'Brand'"
                             class="h-[60px] w-auto object-contain opacity-80 hover:opacity-100 transition-opacity">
                        <span class="text-sm font-medium text-heading text-center">{{ brand.name }}</span>
                    </a>
                    <ng-template #noLink>
                        <div class="flex flex-col items-center justify-center gap-3 bg-surface rounded-lg p-6">
                            <img [src]="brand.asset?.preview"
                                 [alt]="brand.name || 'Brand'"
                                 class="h-[60px] w-auto object-contain opacity-80">
                            <span class="text-sm font-medium text-heading text-center">{{ brand.name }}</span>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </ng-container>

        <ng-template #skeleton>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]"
                     class="flex flex-col items-center justify-center gap-3 bg-surface rounded-lg p-6 animate-pulse">
                    <div class="h-[60px] w-24 bg-gray-200 rounded"></div>
                    <div class="h-4 w-20 bg-gray-200 rounded"></div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
